
var megaMenus = document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details');

for (var i = 0; i < megaMenus.length; i++) {
  megaMenus[i].addEventListener('mouseenter', function () {
    this.setAttribute('open', '');
  });

  megaMenus[i].addEventListener('mouseleave', function () {
    this.removeAttribute('open');
  });
}

var event1 = new MouseEvent('mouseenter', {
  'view': window,
  'bubbles': true,
  'cancelable': true
});

var event2 = new MouseEvent('mouseleave', {
  'view': window,
  'bubbles': true,
  'cancelable': true
});

var subMenus = document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details details');
for (var i = 0; i < subMenus.length; i++) {
  subMenus[i].setAttribute('open', '');
}

var modalButtons = document.querySelectorAll('.modal-button[data-id="languageSelectorButton"]')

modalButtons.forEach(element => {
  element.addEventListener('click', function () {
    document.querySelector('#languageSelectorModal').classList.toggle('open');
  });
});


document.querySelector('#modalClose').addEventListener('click', function () {
  document.querySelector('#languageSelectorModal').classList.remove('open');
});

document.querySelector('#languageSelectorModal').addEventListener('click', function (e) {
  if (e.target.id === 'languageSelectorModal') {
    document.querySelector('#languageSelectorModal').classList.toggle('open');
  }
});

